<!--offer popup-->
<div class="one3d-offer-popup-wrapper">
  <div class="one3d-offer-popup-inner">
    <!--one3d-offer-popup-inner-->
    <div class="one3d-offer-popup-bg">
      <div class="one3d-offer-popup-row1">
        <div class="one3d-offer-close-popup">
          <button (click)="closeOffersPopup()">
            <img src="assets/img/icons/offer-close-icon.svg" alt="icon" />
          </button>
        </div>
        <div class="one3d-offer-popup-row1-img">
          <img [src]="offers?.image" alt="img" />
        </div>
        <div class="one3d-offer-popup-row1-info">
          <p>{{ offers?.offer_name }}</p>
        </div>
      </div>
      <div
        [ngClass]="{ 'one3d-offer-single-card': offers?.offerData?.length === 1 }"
        class="one3d-offer-popup-row2 one3d-offer"
      >
        <ul>
          <li *ngFor="let offer of offers?.offerData">
            <div class="inner">
              <div class="one3d-offer-h1">{{ offer.offer_for }}</div>
              <div class="one3d-offer-h2">{{ offer.title }}</div>
              <div class="one3d-offer-h3" [innerHTML]="offer.description"></div>
              <div class="one3d-offer-h4">
                <i
                  [innerHTML]="
                    offer.showMore
                      ? getSanitizedDynamicText(offer.disclaimer)
                      : (getSanitizedDynamicText(offer.disclaimer)
                        | slice : 0 : 50)
                  "
                ></i>
                <span
                  *ngIf="offer?.disclaimer?.length > 55"
                  (click)="offer.showMore = !offer.showMore"
                >
                  {{ offer.showMore ? "Show less" : "Show More" }}
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="one3d-offers-footer">
        <div class="one3d-test-drive-btn-new">
          <button (click)="testDrive()">BOOK A TEST DRIVE</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!--offer popup-->
